// @flow
import * as actionTypes from "../constants/actionTypes";

export type SetTypeAction = {
  type: "SET_TYPOLOGY",
  payload: { typeIds: Array<string> }
};

export type ToggleTypeAction = {
  type: "TOGGLE_TYPOLOGY_ON_SELECTED_LIST",
  payload: { typeId: string }
};

export type Action = SetTypeAction | ToggleTypeAction;

export function setTypology(typeIds: Array<string>): Action {
  return {
    type: actionTypes.SET_TYPOLOGY,
    payload: {
      typeIds
    }
  };
}

export function toggleTypologyOnSelectedList(typeId: string): Action {
  return {
    type: actionTypes.TOGGLE_TYPOLOGY_ON_SELECTED_LIST,
    payload: {
      typeId
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/typologies.js